'use client';

import { useState, useEffect } from 'react';
import Image from '@referralexchange/rea-ui-react/src/atoms/Image';
import Heading from '@referralexchange/rea-ui-react/src/atoms/Heading';
import Content from '@referralexchange/rea-ui-react/src/atoms/Content';
import Button from '@referralexchange/rea-ui-react/src/atoms/Button';
import Alert from '@referralexchange/rea-ui-react/src/components/modals/Alert';
import Block from '@referralexchange/rea-ui-react/src/components/blocks/Block';
import PropTypes from 'prop-types';
import '@referralexchange/rea-ui-react/src/Utils/css';
import styles from './Success.module.scss';

export default function Success({ isOpen = false, onClose }) {
  const [appElement, setAppElement] = useState(null);

  useEffect(() => {
    setAppElement(document.body);
  }, []);

  return (
    <Alert isOpen={isOpen} onClose={onClose} appElement={appElement} className={styles['alert-modal']}>
      <Block className={styles.success}>
        <Content className={Content.styles.center}>
          <Image
            imageSrc="/static/checkmark_circle.webp"
            alt="checkmark circle icon"
            width={90}
            height={90}
            fill={false}
            className={styles.success__image}
          />
          <Heading
            className={[Heading.styles.center, styles.success__heading].css()}
            tag="h3"
            type="h3"
          >
            Success!
          </Heading>
          <p className={styles.success__message}>
            We have received your message and will reply to you as soon as
            possible
          </p>
          <Button onClick={onClose}>OK</Button>
        </Content>
      </Block>
    </Alert>
  );
}

Success.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
